import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../../context";
import ProjectWindow from "../ProjectWindow/ProjectWindow";
import "./projectsection.css";

const ProjectSection = () => {
    const { projects, goToTop } = useGlobalContext();

    let curWin = 0;

    const nextProject = () => {
        const container = document.getElementById("projectContainer");
        if (container) {
            if (curWin < projects.length) {
                curWin++;
                container.scrollTo(440 * curWin, 0);
            }
        }
    };

    const prevProject = () => {
        const container = document.getElementById("projectContainer");
        if (container) {
            if (curWin > 0) {
                curWin--;
                container.scrollTo(440 * curWin, 0);
            }
        }
    };

    window.addEventListener("scroll", () => {
        const head = document.getElementsByClassName("homeHeading")[0];
        const carousel = document.getElementsByClassName("projectContainer")[0];
        if (head && carousel) {
            var windowHeight = window.innerHeight;
            var elementTop = head.getBoundingClientRect().top;

            if (elementTop < windowHeight - 150) {
                head.classList.add("fadeDown");

                carousel.classList.add("fadeUp");
            }
        }
    });

    return (
        <>
            <div className="projectSectionContainer">
                <h1
                    className="homeHeading"
                    style={{ animationDelay: "200ms", opacity: "0" }}
                >
                    My Projects
                </h1>
                <span className="swipeContainer">
                    <IoIosArrowBack /> Swipe <IoIosArrowForward />
                </span>
                <IoIosArrowBack
                    className="directionLeft"
                    onClick={prevProject}
                />
                <div className="listShadowRight"></div>
                <div className="listShadowLeft"></div>
                <div
                    className="projectContainer"
                    id="projectContainer"
                    style={{ animationDelay: "400ms", opacity: "0" }}
                >
                    {projects.map((project) => {
                        return (
                            <ProjectWindow project={project} key={project.id} />
                        );
                    })}
                </div>
                <IoIosArrowForward
                    className="directionRight"
                    onClick={nextProject}
                />
                <Link
                    to={"/projects"}
                    className="allProjectsBtn"
                    onClick={() => goToTop("projects")}
                >
                    See All Projects
                </Link>
            </div>
        </>
    );
};

export default ProjectSection;
